import { render, staticRenderFns } from "./importFamilias.vue?vue&type=template&id=4a74fc95"
import script from "./importFamilias.vue?vue&type=script&lang=js"
export * from "./importFamilias.vue?vue&type=script&lang=js"
import style0 from "./importFamilias.vue?vue&type=style&index=0&id=4a74fc95&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports